import { render, staticRenderFns } from "./PaymentWrapper.vue?vue&type=template&id=51d15a91&"
import script from "./PaymentWrapper.vue?vue&type=script&lang=js&"
export * from "./PaymentWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports